import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';

export default class UsedInPlaylistsTable extends Component {
  capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);

  render() {
    const { item, data } = this.props;

    if (!item || !data) {
      return null;
    }

    return (
      <div className="mt-2 ml-2 h-[164px] w-full overflow-y-auto rounded-2xl  p-2 bg-white">
        <p
          className="mt-0 mb-2 text-dark-night font-[16px] poppins-bold"
          data-test="used-playlists-title"
        >
          Used in {pluralize('Playlist', data.length, true)}
        </p>
        {data.map(playlist => (
          <div key={`used-in-playlists-${playlist.id}`} className="flex space-x-2 space-y-1">
            <p className="max-w-[calc(100%-20px)] flex-1 truncate text-dark-night">
              {this.capitalize(playlist.name)}
            </p>
            <Link
              to={`/playlists/${playlist.id}`}
              type="button"
              className=" appearance-none h-[20px] flex items-center justify-center w-[20px] bg-[#FF5E00] cursor-pointer"
              onClick={() => {}}
            >
              <img src="/assets/images/icons/right_arrow.svg" alt="view playlist" />
            </Link>
          </div>
        ))}
      </div>
    );
  }
}

UsedInPlaylistsTable.propTypes = {
  item: PropTypes.object,
  data: PropTypes.array,
};
